import {
  Autocomplete,
  FormControl,
  FormLabel,
  Stack,
  TextField,
  Typography,
} from '@mui/material';

import { useDAL } from '@/contexts/useDAL';

import { EmptySelect } from './emptySelect';

export const ResourceGroupSelect = ({
  accountId,
  resourceGroup,
  onChange,
}: {
  accountId?: string;
  resourceGroup?: string;
  onChange: (resourceGroup: string) => void;
}) => {
  if (!accountId) {
    return <EmptySelect title={title} />;
  }

  return (
    <InnerResourceGroupSelect
      accountId={accountId}
      resourceGroup={resourceGroup}
      onChange={onChange}
    />
  );
};

const title = 'Resource Group';

const InnerResourceGroupSelect = ({
  accountId,
  resourceGroup,
  onChange,
}: {
  accountId: string;
  resourceGroup?: string;
  onChange: (resourceGroup: string) => void;
}) => {
  const dal = useDAL();
  const { data: body } =
    dal.restore.azureRestoreConfig.useListResourceGroups(accountId);

  if (!body?.resourceGroups?.length) {
    return <EmptySelect title={title} />;
  }

  return (
    <FormControl size='small' className='flex-1'>
      <FormLabel>{title}</FormLabel>
      <Autocomplete
        clearOnBlur
        size='small'
        value={
          body?.resourceGroups.find((rg) => rg.name === resourceGroup) || null
        }
        onChange={(event, newValue) => onChange(newValue?.name || '')}
        getOptionLabel={(option) => option.name}
        renderOption={(props, group) => (
          <li {...props} key={group.name}>
            <Stack className='py-[4px]'>
              <Typography>{group.name}</Typography>
              <Typography variant='body2' className='mt-[4px]'>
                {group.location}
              </Typography>
            </Stack>
          </li>
        )}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              placeholder='Select'
              label=''
              InputLabelProps={{ shrink: true }}
            />
          );
        }}
        options={body.resourceGroups}
      />
    </FormControl>
  );
};
